'use strict';
import React, { PureComponent } from 'react';
import { createForm } from 'rc-form';
import Table from './Tabla/Table'
import Header from './Header'
import { Redirect } from 'react-router-dom';
import Buscador from './Buscador';

class ConfiguracionProcesos extends PureComponent {
    constructor(props) {
        super(props);
    }


    componentDidMount() {
        this.props.getScreenData(this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {
        const { procesos,
            column,
            columnIndex,
            checkActivo,
            redirect,
            administratorSelected,
            procesosAll,
            inputBuscador,
            administradorasActivas,
            loadingConfiguracionProcesos,
            columnaActivaOrdenamiento
        } = this.props.data;

        if (redirect.shouldRedirect)
            return <Redirect to={redirect.to} push />;

        let componente = <div id="loading" className="loading" />;

        let procesosActivos = checkActivo ? procesosAll.filter(x => x.EstaActivo == true) : procesosAll

        if (!loadingConfiguracionProcesos) {

            componente = <div className="container">
                <div className="container-fluid row">
                    <div className="row lineMenuProcesos">
                        <div className="col-md-12 ">
                            <div className="firaTitulo ">Configuración de procesos</div>
                        </div>
                    </div>

                    <Buscador 
                        procesos={procesosActivos}
                        buscarProcesos={this.props.buscarProcesos}
                        inputBuscador={inputBuscador}
                    />

                    <Header
                        checkActivo={checkActivo}
                        selectCheckBox={this.props.setCheckActive}
                        procesos={procesos}
                        selectTab={this.props.selectTab}
                        administratorSelected={administratorSelected}
                        administradorasActivas={administradorasActivas}
                    />
                    <Table procesos={procesos}
                        columnaActivaOrdenamiento={columnaActivaOrdenamiento}
                        administratorSelected={administratorSelected}
                        checkActivo={checkActivo}
                        column={column}
                        orderColumn={this.props.orderColumn}
                        columnIndex={columnIndex}
                        routeToEditarConfiguracionProceso={this.props.routeToEditarConfiguracionProceso}
                    />

                </div>

            </div>
        }

        return (
            <div>
                {componente}
            </div>
        );
    }
}

export default createForm()(ConfiguracionProcesos);